import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Slideshow from './Slideshow';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="homepage">
      <Header 
        rightButton={
          <Link to="/about" className="nav-link contact-btn">
            Contact Us
          </Link>
        }
      />
      
      <main className="main-content">
        <Slideshow />
      </main>
      <footer className="footer-banner">
        <div className="footer-content">
          <p>&copy; 2025 SparkLabs LLC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
